module.exports = {
      id: "plane-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#plane-usage",
      toString: function () {
        return this.url;
      }
    }